import { postRequest } from "../helpers/axios";
import { TrackedEvent } from "./analytics/types";
import { ANALYTICS_EVENTS } from "./api-urls";

export function postAggregatedEvents(events: TrackedEvent[]) {
  return postRequest<TrackedEvent[]>(ANALYTICS_EVENTS, {
    data: JSON.stringify(events)
  });
}
